import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MapGoogleService } from 'src/app/services/map-google.service';

@Component({
  selector: 'app-team-vehicle',
  templateUrl: './team-vehicle.component.html',
  styleUrls: ['./team-vehicle.component.css']
})
export class TeamVehicleComponent implements OnInit {

  @Input() teamVehicle;

  url = '';

  imgRoundedTeam;
  imgRoundedVehicle;

  constructor(
    public _mapGoogleService: MapGoogleService,
  ) { }

  ngOnInit(): void {
    this.imgRoundedVehicle = this.teamVehicle?.vehicle?.vehicleImage?.url ? this.teamVehicle?.vehicle?.vehicleImage?.url : 'assets/icons/camera.svg';
    this.imgRoundedTeam = this.teamVehicle?.leaderMember?.user?.imageURL ? this.teamVehicle?.leaderMember?.user?.imageURL : 'assets/icons/camera.svg';

  }

  openTeamVehicleDetails() {
    this._mapGoogleService.sidebarMapOpen = true;
  }
}
